export enum PAGETITLE {
  TRANSACTION_ACCOUNT = 'Billing account',
  INVOICE_GROUP = 'Billing profile',
  SUBSCRIPTION = 'Entitlement',
  ADD_ONS = 'Add-On',
  SEARCH_PAGE = 'Search',
  INVOICE = 'Invoice',
  CREDIT_NOTES = 'Credit note',
  CATALOG = 'Catalog',
  CONTACT = 'Contact',
  PARTNER = 'Partner',
  EMAIL = 'Email',
  SERVER_LICENSE = 'Server license',
  SERVICE = 'Service',
  SUPPORT_ISSUE = 'Support issue',
  QUOTE = 'Quote',
  TRANSACTION_ACCOUNT_BALANCE = 'Transaction account balance',
  CLOUD_SITE = 'Cloud site',
  ORGANIZATION = 'Organization',
  BITBUCKET = 'Bitbucket',
  ATLASSIAN_ACCESS = 'Atlassian access',
  TRELLO = 'Trello',
  OPSGENIE = 'Opsgenie',
  PRODUCT = 'Product',
  APPROVAL_DESK = 'Approval desk',
  CREDIT_DETAIL = 'Credit detail',
  DOMAIN = 'Domain',
}

export enum APPLICATION_TITLE {
  ADVOCATE_CENTRAL = 'Advocate central',
  PPC = 'Partner Purchasing Center',
}
